import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import "../../cssfiles/homepage.css";
import CustomLabel from "../CommonComponents/CustomLabel";
import {
  emailReport,
  getGeneratedReports,
  getUserGroupReports,
  viewGeneratedReport,
} from "../../Restclient/datacollection";
import CustomButton from "../CommonComponents/CustomButton";
import { useSelector } from "react-redux";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomMultiselectWithCheckbox from "../CommonComponents/CustomMultiselectWithCheckbox";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import LK_Loading from "../../images/LK_Loading.gif";

export default function View() {
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );

  const username = useSelector((state) => state.logindata.username);
  const theme = useSelector((state) => state.themedata.theme);

  const table_head = ["Report", "Generated At", "View", "Email"];
  const [popup, setPopup] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [selIndex, setSelIndex] = useState(-1);

  const [reportList, setReportList] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const handleUsers = (assets) => {
    setSelectedUsers(assets);
  };

  const callbackreports = (res) => {
    setReportList(res.data);
  };

  const callbackuser = (res) => {
    setUserOptions(res.data.names);
  };

  useEffect(() => {
    getGeneratedReports(username, callbackreports);
    getUserGroupReports(callbackuser);
  }, [projectId]);

  const [selectedGroup, setSelectedGroup] = useState("");

  const [templateList, setTemplateList] = useState([]);
  const [templateDynamic, setTemplateDynamic] = useState([]);
  const [templateType, setTemplateType] = useState([]);
  const [templateInterval, setTemplateInterval] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState([]);
  const [dynamic, setDynamic] = useState(false);
  const [tempType, setTempType] = useState("Archive");
  const handleTemplateChange = (value) => {
    setSelectedTemplate(value);
    setDynamic(templateDynamic[templateList.indexOf(value)]);
    setTempType(templateType[templateList.indexOf(value)]);
    setSelctedTimePeriod(templateInterval[templateList.indexOf(value)]);
  };

  const [selectedTimePeriod, setSelctedTimePeriod] = useState("Today");
  const now = new Date();
  const [startDT, setStartDT] = useState(
    new Date(now.setHours(0, 0, 0, 0)).toString(),
  );
  const [endDT, setEndDT] = useState(new Date().toString());
  const handleDateTime = (startdate, enddate) => {
    setStartDT(startdate);
    setEndDT(enddate);
  };

  const [update, setUpdate] = useState(-1);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (update !== 2) setUpdate(-1);
    }, 3000);
    return () => clearTimeout(timer);
  }, [update]);

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [reportView, setReportView] = useState(false);
  const [file, setFile] = useState();

  const handleClose = (event, reason) => {
    if (reason === "closeButton") {
      setSelIndex(-1);
      setPopup(false);
      setReportView(false);
      setFile();
    }
  };

  const callbackReport = (resfile) => {
    setIsDataLoading(false);
    const blob = new Blob([resfile], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setFile(url);
  };

  const handleGenerateReport = (index) => {
    setIsDataLoading(true);
    viewGeneratedReport(index, callbackReport);
    setReportView(true);
  };

  const callbackEmail = (res) => {
    setUpdate(res.data);
  };

  const sendEmail = () => {
    setUpdate(2);
    emailReport(selIndex, selectedUsers, callbackEmail);
  };

  return (
    <div className="templateGroup">
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          gap: "8px",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            height: "100%",
            paddingLeft: "0px",
            backgroundColor: "var(--secondary-backgroundLK)",
            paddingRight: "0px",
          }}
          elevation={0}
        >
          <Table stickyHeader sx={{ width: "100%" }} size="small">
            <TableHead>
              <TableRow sx={{ border: "0px" }}>
                {table_head.map((table_head_value, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      textAlign: "left",
                      fontSize: "12px",
                      fontWeight: 700,
                      color: "var(--grey-variation-tableLK)",
                      backgroundColor: "var(--secondary-backgroundLK)",
                    }}
                  >
                    {table_head_value}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {reportList.map((row, rowIndex) => (
                <TableRow
                  key={rowIndex + 1}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    height: "9px",
                    "& > *": {
                      borderBottom: "1px solid var(--table-boarder-line)",
                    },
                  }}
                >
                  {row.map((cell, cellIndex) => (
                    <>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "var(--grey-variation-tablerowsLK)",
                        }}
                      >
                        {cellIndex === 0 || cellIndex === 1 ? (
                          cell
                        ) : cellIndex === 2 ? (
                          <CustomActionButton
                            buttonText={"View"}
                            onClick={() => handleGenerateReport(cell)}
                          />
                        ) : (
                          <CustomActionButton
                            buttonText={"Email"}
                            onClick={() => {
                              setPopup(true);
                              setSelIndex(cell);
                            }}
                          />
                        )}
                      </TableCell>
                    </>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {
        <Dialog
          maxWidth={"xl"}
          open={reportView}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              event.preventDefault();
            } else {
              handleClose(event, reason);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            sx: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  Report
                </Typography>
                <Box sx={{ flexGrow: 1 }}> </Box>

                <Button
                  variant="outlined"
                  sx={{
                    width: "60px",
                    height: "30px",
                    borderRadius: "20px",
                    borderColor: "#5B5B5B",
                    color: "#5B5B5B",
                    textTransform: "none",
                  }}
                  onClick={(event) => handleClose(event, "closeButton")}
                >
                  {" "}
                  Close{" "}
                </Button>
              </Box>
              {isDataLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "calc(100vh - 200px)",
                    width: "1000px",
                  }}
                >
                  <img
                    src={LK_Loading}
                    alt="Loading..."
                    className="loading-popup" // Adjust size here
                  />
                </Box>
              ) : (
                <iframe
                  className="Test 123 iframe-report"
                  src={file}
                  type="application/pdf"
                  width="1000px"
                  aria-label="PDF file"
                ></iframe>
              )}
            </>
          </DialogContent>
        </Dialog>
      }
      {
        <Dialog
          maxWidth={"l"}
          open={popup}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              event.preventDefault();
            } else {
              handleClose(event, reason);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            sx: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                }}
              >
                <Box sx={{ flexGrow: 1 }}> </Box>

                <CustomButton
                  buttonText={"Send"}
                  onClick={sendEmail}
                  disabled={update === 2 ? true : false}
                />
                <Box sx={{ width: "8px", height: "8px" }}></Box>
                <CustomCancelButton
                  buttonText={"Close"}
                  onClick={(event) => handleClose(event, "closeButton")}
                />
              </Box>
              <div>
                <table width="100%" className=".generate-table">
                  <tr>
                    <td className="view-table-td">
                      <CustomLabel
                        labelText={"Select User Groups*"}
                        htmlFor={"user-group"}
                        color={"var(--SecondaryText)"}
                        paddingTop={6}
                      />
                    </td>
                    <td colSpan={2} className="generate-table-td">
                      <CustomMultiselectWithCheckbox
                        options={userOptions}
                        width={227}
                        onChange={handleUsers}
                        selecteddata={selectedUsers}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} className="view-table-td-center">
                      {update === 1 ? (
                        <CustomLabel
                          labelText={"Email sent successfully!"}
                          color={"green"}
                        />
                      ) : update === 0 ? (
                        <CustomLabel
                          labelText={"Error in sending email!"}
                          color={"red"}
                        />
                      ) : update === 2 ? (
                        <CustomLabel
                          labelText={"Sending Email..."}
                          color={"black"}
                        />
                      ) : (
                        <label className="view-label-hidden">Email</label>
                      )}
                    </td>
                  </tr>
                </table>
              </div>
            </>
          </DialogContent>
        </Dialog>
      }
    </div>
  );
}
